import angular from 'angular';
import {
  bcpDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { confirmDialog, alerts, } from 'app/components/global';
import bcpUtilityService from 'app/services/bcp.utility.service';
import editAuthorityAndManagementDialog from './dialog.editAuthorityAndManagementDialog';
import editInternalContactDialog from './dialog.editInternalContactDialog';
import controller from './authority-and-management.controller';
import directive from './authority-and-management.directive';


export default angular.module('app.components.advisory.bcp.authorityAndManagement', [
  confirmDialog,
  alerts,
  bcpDataService,
  editAuthorityAndManagementDialog,
  editInternalContactDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  bcpUtilityService,
])
  .directive('bcpAuthorityAndManagement', directive)
  .controller('AuthorityAndManagementController', controller)
  .name;

console.log('app.components.advisory.bcp.authorityAndManagement created');
